import {
  parseTime,
} from '@/utils';

/**
 * 格式化时间
 *
 * @export
 * @param {*} date 时间戳
 * @param {string} [pattern = 'yyyy-MM-dd HH:mm:ss'] 格式
 * @returns
 */
export function formatTime(date, pattern = 'yyyy-MM-dd HH:mm:ss') {
  if (!date) {
    return '/';
  }
  const number = Number(date);
  // eslint-disable-next-line no-restricted-globals
  if (!isNaN(number)) {
    // eslint-disable-next-line no-param-reassign
    date = number;
  }
  return parseTime(date, pattern);
}
